var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('section',{staticClass:"hero"},[_c('div',{staticClass:"hero-body"},[_c('div',{key:"logoutBtn",staticClass:"buttons"},[_c('router-link',{staticClass:"button is-primary",style:({
            backgroundColor: '#1062FE',
            marginLeft: '15px',
          }),attrs:{"to":"/dashboard/discord/redirect"}},[_c('strong',[_vm._v("Login with Discord")])])],1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }